import React from "react";

import clsx from "clsx";

import Image from "~/common/components/CustomImage";

import ChatbotActionButton from "./ChatbotActionButton";
import styles from "./JoinUsSection.module.scss";

export default function JoinUsSection({
  buttonProps,
  imageSrc,
  title,
  description,
  buttonText,
  variant = "main",
  className,
}) {
  const rootClass = clsx("JoinUsSection", variant && `JoinUsSection--${variant}`, styles.container, className);

  return (
    <div className={rootClass}>
      {imageSrc && (
        <div className={clsx("JoinUsSection__imageWrapper", styles.imgContainer)}>
          <Image src={imageSrc} alt={title || "Banner"} fill style={{ objectFit: "cover" }} sizes="100vw" />
        </div>
      )}
      {title && (
        <div className={clsx("JoinUsSection__card", "card")}>
          <div className={clsx("JoinUsSection__content", styles.innerContainer)}>
            <h2 className="JoinUsSection__title">{title}</h2>
            <p className="JoinUsSection__description">{description}</p>
            <ChatbotActionButton {...buttonProps} className="JoinUsSection__button">
              {buttonText}
            </ChatbotActionButton>
          </div>
        </div>
      )}
    </div>
  );
}
